export default { default: {} };

export const specialMessageMap = {
    else: 'control_else',
};
